import React, { Component, Fragment } from 'react';
import T from 'components/common/translations/Translate';
import { connect } from 'react-redux';
import HeaderBack from 'components/components/account/components/HeaderBack';
import withRouter from 'components/components/common/withRouter';
import { setUserLogout } from 'components/actions/authActions';
import AppLink from 'components/common/AppLink';

class HortenTorp extends Component {

  render() {
    const { isLogged } = this.props;

    return (
      <div className="content content--lp content--lp-text horten-torp">
        {isLogged &&
          <HeaderBack
            locale={this.props.locale}
            name="content.layout.sidebarAndHeader.help"
            link="routes.url.help"
            title="content.layout.sidebarAndHeader.backToHelpTitle"
            className="header-back--lp" />
        }

        {/* HERO */}
        <section className="ht-section ht-hero">
          <div className="ht-container">
            <h1><T>content.landing.hortenTorp.title</T></h1>
            <p><T>content.landing.hortenTorp.intro</T></p>
            <AppLink to="routes.url.booking" className="ht-btn">
              <T>content.landing.hortenTorp.heroButton</T>
            </AppLink>
          </div>
        </section>

        {/* FEATURE */}
        <section className="ht-section ht-feature">
          <div className="ht-container">
            <div className="ht-feature-box">
              <span className="ht-feature-icon" role="img" aria-label="ferry">🚢</span>
              <h3><T>content.landing.hortenTorp.feature.title</T></h3>
              <p><T>content.landing.hortenTorp.feature.description</T></p>
            </div>
          </div>
        </section>

        {/* COMPARISON */}
        <section className="ht-section ht-comparison">
          <div className="ht-container">
            <h2 className="ht-section-title"><T>content.landing.hortenTorp.comparison.title</T></h2>
            <p className="ht-section-subtitle"><T>content.landing.hortenTorp.comparison.subtitle</T></p>

            <div className="ht-table-responsive">
              <table>
                <thead>
                  <tr>
                    <th><T>content.landing.hortenTorp.comparison.columns.method</T></th>
                    <th><T>content.landing.hortenTorp.comparison.columns.time</T></th>
                    <th><T>content.landing.hortenTorp.comparison.columns.cost</T></th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="ht-highlighted-row">
                    <td><strong><T>content.landing.hortenTorp.comparison.flyo.name</T></strong></td>
                    <td><T>content.landing.hortenTorp.comparison.flyo.time</T></td>
                    <td><T>content.landing.hortenTorp.comparison.flyo.cost</T></td>
                  </tr>
                  <tr>
                    <td><strong><T>content.landing.hortenTorp.comparison.car.name</T></strong></td>
                    <td><T>content.landing.hortenTorp.comparison.car.time</T></td>
                    <td><T>content.landing.hortenTorp.comparison.car.cost</T></td>
                  </tr>
                  <tr>
                    <td><strong><T>content.landing.hortenTorp.comparison.train.name</T></strong></td>
                    <td><T>content.landing.hortenTorp.comparison.train.time</T></td>
                    <td><T>content.landing.hortenTorp.comparison.train.cost</T></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* STEPS */}
        <section className="ht-section ht-steps">
          <div className="ht-container">
            <h2 className="ht-section-title"><T>content.landing.hortenTorp.steps.title</T></h2>
            <p className="ht-section-subtitle"><T>content.landing.hortenTorp.steps.subtitle</T></p>

            <div className="ht-steps-grid">
              <div className="ht-step-card">
                <div className="ht-step-num">1</div>
                <h4><T>content.landing.hortenTorp.steps.first.title</T></h4>
                <p><T>content.landing.hortenTorp.steps.first.description</T></p>
              </div>
              <div className="ht-step-card">
                <div className="ht-step-num">2</div>
                <h4><T>content.landing.hortenTorp.steps.second.title</T></h4>
                <p><T>content.landing.hortenTorp.steps.second.description</T></p>
              </div>
              <div className="ht-step-card">
                <div className="ht-step-num">3</div>
                <h4><T>content.landing.hortenTorp.steps.third.title</T></h4>
                <p><T>content.landing.hortenTorp.steps.third.description</T></p>
              </div>
              <div className="ht-step-card">
                <div className="ht-step-num">4</div>
                <h4><T>content.landing.hortenTorp.steps.fourth.title</T></h4>
                <p><T>content.landing.hortenTorp.steps.fourth.description</T></p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="ht-section ht-faq">
          <div className="ht-container">
            <h2 className="ht-section-title"><T>content.landing.hortenTorp.faq.title</T></h2>
            <p className="ht-section-subtitle"><T>content.landing.hortenTorp.faq.subtitle</T></p>

            <div className="ht-faq-item">
              <p className="ht-faq-question"><T>content.landing.hortenTorp.faq.first.question</T></p>
              <p className="ht-faq-answer"><T>content.landing.hortenTorp.faq.first.answer</T></p>
            </div>
            <div className="ht-faq-item">
              <p className="ht-faq-question"><T>content.landing.hortenTorp.faq.second.question</T></p>
              <p className="ht-faq-answer"><T>content.landing.hortenTorp.faq.second.answer</T></p>
            </div>
            <div className="ht-faq-item">
              <p className="ht-faq-question"><T>content.landing.hortenTorp.faq.third.question</T></p>
              <p className="ht-faq-answer"><T>content.landing.hortenTorp.faq.third.answer</T></p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="ht-section ht-cta">
          <div className="ht-container">
            <h2><T>content.landing.hortenTorp.bottomCta.title</T></h2>
            <p><T>content.landing.hortenTorp.bottomCta.description</T></p>
            <AppLink to="routes.url.prices" className="ht-btn ht-btn--light">
              <T>content.landing.hortenTorp.bottomCta.button</T>
            </AppLink>
          </div>
        </section>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogout }
  )(HortenTorp));
